import React from 'react';
import './DesktopFooter.css';

const DesktopFooter = () => {
  return (
    <footer className="desktop-footer">
      <div className="desktop-footer-content">
        <ul className="desktop-footer-links">
          <li><a href="/" className="desktop-footer-link">Home</a></li>
          <li><a href="/quiz" className="desktop-footer-link">Character Quiz</a></li>
          <li><a href="/image-quiz" className="desktop-footer-link">Image Quiz</a></li>
          <li><a href="/devil-fruit-quiz" className="desktop-footer-link">Devil Fruit Quiz</a></li>
        </ul>

        <ul className="desktop-footer-links legal-links">
          <li><a href="/about" className="desktop-footer-link">About</a></li>
          <li><a href="/contact" className="desktop-footer-link">Contact</a></li>
          <li><a href="/privacy" className="desktop-footer-link">Privacy Policy</a></li>
          <li><a href="/terms" className="desktop-footer-link">Terms of Service</a></li>
        </ul>

        <div className="desktop-footer-info">
          <p>&copy; {new Date().getFullYear()} One Piece Trivia by ChibiDash.</p>
          <p className="disclaimer">
            This is an unofficial fan-made site. It is not affiliated with, endorsed by,
            sponsored by or approved by Eiichiro Oda, Shueisha, Toei Animation or any of
            their partners.
          </p>
          <p className="disclaimer">
            &ldquo;One Piece&rdquo;, its characters, names and related marks are the property of
            their respective owners. Character images appear here for identification only
            and remain the property of their owners. The quiz questions and site text are
            our own.
          </p>
          <p className="disclaimer">
            If you hold rights to anything shown here and would like it taken down,
            email us and it will be removed.
          </p>
          <p className="contact-info">Contact: chibidashofficial@gmail.com</p>
        </div>
      </div>
    </footer>
  );
};

export default DesktopFooter;